import React from 'react';
import classNames from 'classnames';
import rarity from 'assets/svg/hero_rarity.svg';
import styles from './styles.module.scss';
import { colorMap } from './config';

const HeroRarityCard = ({
  className,
  value
}) => {
  const {
    displayValue,
    color
  } = colorMap[value];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, /*#__PURE__*/React.createElement("img", {
    src: rarity,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Hero Rarity"), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.rarity, styles[color])
  }, displayValue)));
};

export default HeroRarityCard;